export const getStorageKeys = (isCompact?: boolean) =>
  isCompact
    ? {
        dayRange: 'site-orders-days-range',
        status: 'site-orders-all-status',
      }
    : {
        dayRange: 'order-management-days-range',
        status: 'order-management-all-status',
      }
